import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Block } from '../block/block'
import { CheckboxContext } from './checkbox.context'

export const CheckboxGroup = ({
  disabled = false,
  onChange,
  value = [],
  children,
  className,
  style,
  ...rest
}) => {
  const [currentValues, setCurrentValues] = useState([])
  const providerValue = useMemo(() => {
    return {
      updateState,
      disabledAll: disabled,
      inGroup: true,
      values: currentValues
    }
  }, [disabled, currentValues])

  useEffect(() => {
    setCurrentValues(value)
  }, [value.join(',')])

  function updateState(value, checked) {
    const removed = currentValues.filter(v => v !== value)
    const nextValues = checked ? [...removed, value] : removed
    setCurrentValues(nextValues)
    onChange?.(nextValues)
  }

  return (
    <CheckboxContext.Provider value={providerValue}>
      <StyledCheckboxGroup role='group' gap={16} {...rest}>
        {children}
      </StyledCheckboxGroup>
    </CheckboxContext.Provider>
  )
}

const StyledCheckboxGroup = styled(Block)``
